import React, { forwardRef, ChangeEvent } from 'react';
import { FormSectionTitle } from '../atoms/FormSectionTitle';
import { RequiredLabel } from './RequiredLabel';

type LabeledInquiryFieldProps = {
  title: string;
  inline?: boolean;
  className?: string;
  ariaLabel?: string;
  rows?: number;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
} & Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'>;

export const LabeledInquiryField = forwardRef<HTMLTextAreaElement, LabeledInquiryFieldProps>(
  (_props, ref) => {
    const { inline, title, className, ariaLabel, rows = 3, onChange, ...props } = _props;
    return (
      <div className={inline ? 'inline-block' : 'block'}>
        <div className="flex items-center gap-2">
          <FormSectionTitle text={title} htmlFor={props.id} />
          <RequiredLabel id={props.id} />
        </div>
        <textarea
          className={`w-full bg-[--c-textinput-background] border border-[--c-textinput-border] rounded-[8px] p-2 ${className || ''}`}
          aria-label={ariaLabel}
          rows={rows}
          onChange={onChange}
          {...props}
          ref={ref}
        />
      </div>
    );
  }
);
LabeledInquiryField.displayName = 'LabeledInquiryField';
